"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_CREATE = 'modal-create';
exports.MODAL_UPDATE = 'modal-update';
exports.BANNER = 'BANNER';
exports.LICENSE_ENTERPRISE = 'Khach-hang-tich-hop-Enterprise';
exports.LICENSE_BASIC = 'Khach-hang-tich-hop';
exports.LICENSE = 'License';
exports.MGN = 'MGN';
exports.ZEROED_MAC_ADDR = '00:00:00:00:00:00';
exports.optimizeTypes = [
    {
        name: 'CPC',
        desc: 'Use your budget to get as many clicks as possible.',
        sub: 'Cost per click'
    },
    {
        name: 'CPM',
        desc: 'Use your budget to show as many ads as possible',
        sub: 'Cost per 1000 impressions'
    }
];
exports.basicLocationInfo = ['name', 'city', 'categoryId', 'address', 'district'];
exports.advanceLocationInfo = ['shareType', 'status', 'stats', 'activeDay', 'configAuth'];
exports.OsType = [
    'Android',
    'Windows',
    'Windows Phone',
    'Mac OS X',
    'iOS',
    'Linux',
    'Ubuntu',
    'BlackBerry OS',
    'Other'
];
exports.DeviceType = ['Mobile', 'PC', 'Tablet', 'Other'];
exports.optimizeTypesOnline = [
    {
        name: 'CPC',
        desc: 'Use your budget to get as many clicks as possible.',
        sub: 'Cost per click'
    },
    {
        name: 'CPV',
        desc: 'Use your budget to get as many clicks as possible.',
        sub: 'Cost per 1000 impressions'
    },
    {
        name: 'Other',
        desc: 'Use your budget to get as many clicks as possible.'
    }
];
//# sourceMappingURL=others.js.map